// NHS Sticky Product Media — scroll-position based approach
// Uses transform instead of position:sticky to bypass overflow:hidden ancestors
(function() {
  if (window.innerWidth < 990) return;

  function init() {
    var wrapper = document.querySelector('.product__media-wrapper');
    var infoWrapper = document.querySelector('.product__info-wrapper');
    if (!wrapper || !infoWrapper) return;

    var mediaGallery = wrapper.querySelector('media-gallery');
    if (!mediaGallery) return;

    var ticking = false;
    var currentY = 0;
    var targetY = 0;
    var animating = false;

    // Smooth CSS transition for the gallery
    mediaGallery.style.transition = 'transform 0.15s ease-out';
    mediaGallery.style.willChange = 'transform';

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function() {
          update();
          ticking = false;
        });
        ticking = true;
      }
    }

    function update() {
      var wrapperRect = wrapper.getBoundingClientRect();
      var galleryHeight = mediaGallery.offsetHeight;
      var gap = 20;

      var scrolledPast = -wrapperRect.top + gap;
      var maxTranslate = infoWrapper.offsetHeight - galleryHeight;

      if (scrolledPast <= 0 || maxTranslate <= 0) {
        targetY = 0;
      } else if (scrolledPast >= maxTranslate) {
        targetY = maxTranslate;
      } else {
        targetY = scrolledPast;
      }

      mediaGallery.style.transform = 'translateY(' + targetY + 'px)';
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function() {
      if (window.innerWidth < 990) {
        mediaGallery.style.transform = '';
      }
    });

    // Initial call
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(init, 500); });
  } else {
    setTimeout(init, 500);
  }
})();
